module.exports = __webpack_public_path__ + "img/m_bg.c7f52600.jpg";